"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgEmptyHotelMap = function SvgEmptyHotelMap(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 152 89"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "empty-hotel-map_svg__a",
    d: "m35 20 26 10v58L35 78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "empty-hotel-map_svg__b",
    d: "m60 20 26 10v58L60 78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "empty-hotel-map_svg__c",
    d: "m85 20 26 10v58L85 78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "empty-hotel-map_svg__d",
    d: "M38 23.731a7.33 7.33 0 0 0 .7 3.156C40.7 31.117 45.87 37 46 37c.13 0 5.3-5.883 7.3-10.113.465-.982.7-2.044.7-3.156C54 19.468 50.41 16 46 16c-4.411 0-8 3.468-8 7.731z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "empty-hotel-map_svg__e",
    width: 26,
    height: 68,
    x: 0,
    y: 0,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-hotel-map_svg__a"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "empty-hotel-map_svg__f",
    width: 26,
    height: 68,
    x: 0,
    y: 0,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-hotel-map_svg__b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "empty-hotel-map_svg__g",
    width: 26,
    height: 68,
    x: 0,
    y: 0,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-hotel-map_svg__c"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "empty-hotel-map_svg__h",
    width: 16,
    height: 21,
    x: 0,
    y: 0,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-hotel-map_svg__d"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E1F3FF",
    d: "M111 20v58l-25 9.615V88l-.5-.192L85 88v-.385l-24.5-9.423L35 88v-4.539l21.5-8.269L81 84.615V85l.5-.192.5.192v-.385L107 75V21.539L111 20z"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#919499",
    strokeDasharray: 2,
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#empty-hotel-map_svg__e)",
    transform: "matrix(-1 0 0 1 96 0)",
    xlinkHref: "#empty-hotel-map_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#919499",
    strokeDasharray: 2,
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#empty-hotel-map_svg__f)",
    xlinkHref: "#empty-hotel-map_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#919499",
    strokeDasharray: 2,
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#empty-hotel-map_svg__g)",
    transform: "matrix(-1 0 0 1 196 0)",
    xlinkHref: "#empty-hotel-map_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m10 28-5.878 3.09 1.123-6.545L.489 19.91l6.572-.955L10 13l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545zm128-6.441L129.348 26 131 16.593l-7-6.662 9.674-1.372L138 0l4.326 8.559L152 9.93l-7 6.662L146.652 26zM119.5 86.95 115.483 89l.767-4.342-3.25-3.074 4.491-.634L119.5 77l2.009 3.95 4.491.634-3.25 3.074.767 4.342z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59 47)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#17181A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 2,
    r: 2,
    fill: "#17181A"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#17181A",
    d: "M4 14c7.113-2.667 14.113-2.667 21 0"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#EDEDED",
    stroke: "#919499",
    strokeDasharray: 2.509,
    strokeLinejoin: "round",
    strokeWidth: 2.509,
    mask: "url(#empty-hotel-map_svg__h)",
    xlinkHref: "#empty-hotel-map_svg__d"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgEmptyHotelMap);
var _default = exports["default"] = Memo;